import { render } from "./App.vue?vue&type=template&id=67e7717b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=67e7717b&lang=scss"

import exportComponent from "D:\\dev\\vuejs\\nafn\\nafn.urmull.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__